<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    app
    clipped
    permanent
    color="primary"
    dark
    expand-on-hover
  >
    <Menu :items="visibleItems" />
  </v-navigation-drawer>
</template>

<script>
import Menu from "#Components/admin/structure/Menu";
export default {
  name: "Admin_Structure_Drawer",

  components: {
    Menu,
  },

  data: () => ({
    drawer: true,
    mini: true,
    items: [
      {
        title: "Dashboard",
        icon: "mdi-desktop-mac-dashboard",
        name: "app.index",
      },
      {
        title: "Setup",
        icon: "mdi-notebook-multiple",
        name: "app.setup",
      },
      /*{
        title: 'ASK Agency',
        icon: 'mdi-thought-bubble',
        children: [
          {
            title: 'Mapping',
            icon: 'mdi-xml',
            children: [
              {
                title: 'Bing',
                name: 'app.iac.mapping.bing',
                icon: 'mdi-microsoft-bing'
              },
              {
                title: 'Yahoo!',
                name: 'app.index',
                icon: 'mdi-yahoo'
              }
            ]
          }
        ]
      }*/
    ],
  }),

  computed: {
    visibleItems() {
      //return this.items.filter(this.userCanRouteTo);
      return this.items;
    },
  },

  methods: {
    routeToItem(item) {
      if (item.name) {
        return { name: item.name };
      }
      return { path: item.path };
    },

    userCanRouteTo(item) {
      if (item.children) {
        item.children = item.children.filter(this.userCanRouteTo);
        if (item.children.length == 0) {
          return false;
        } else {
          return true;
        }
      }

      if (!item.name) {
        return true;
      }

      let props = this.$router.resolve({
        name: item.name,
      });

      if (!props.route || !props.route.meta) {
        //|| !props.route.meta.role) {
        return true;
      }

      if (!props.route.meta.role) {
        props.route.meta.role = "all";
      }

      if (!props.route.meta.module) {
        props.route.meta.module = "";
      }

      return (
        this.$hasRole(props.route.meta.role) &&
        this.$hasModule(props.route.meta.module)
      );
    },
  },
};
</script>
